import { createActions, createReducer } from 'reduxsauce'

import VinculoService from '../servicos/VinculoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaVinculoInicio: [],
    buscaVinculoSucesso: ['vinculo'],
    buscaVinculoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaVinculos = () => {
    return dispatch => {
        dispatch(Creators.buscaVinculoInicio())
        let serv = new VinculoService()
        return serv
            .getVinculo()
            .then(response => dispatch(Creators.buscaVinculoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaVinculoErro(error)))
    }
}

const buscaVinculoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaVinculoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaVinculoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.vinculo, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_VINCULO_INICIO]: buscaVinculoInicio,
    [Types.BUSCA_VINCULO_ERRO]: buscaVinculoErro,
    [Types.BUSCA_VINCULO_SUCESSO]: buscaVinculoSucesso,
})
